declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  // Setup fbq queue function
  if (!window.fbq) {
    const n: any = (window.fbq = function () {
      if (n.callMethod) {
        n.callMethod.apply(n, arguments)
      } else {
        n.queue.push(arguments)
      }
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
  }

  // Load the Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Use head or body as fallback
  const target =
    document.head || document.getElementsByTagName('head')[0] || document.body
  target.appendChild(script)

  // Initialize pixel
  window.fbq('init', '2434317904073238')

  // Also add noscript image fallback
  const noscript = document.createElement('img')
  noscript.height = 1
  noscript.width = 1
  noscript.style.display = 'none'
  noscript.src =
    'https://www.facebook.com/tr?id=2434317904073238&ev=PageView&noscript=1'
  document.body.appendChild(noscript)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Código del Crédito 750+',
      content_type: 'product',
      value: 9.36,
      currency: 'USD',
    })
  }
}
